import { gql, TypedDocumentNode } from '@apollo/client'

import type { LabelDTO } from 'features/ab-tests/api/types/abTestsParametersSchemaDTO'

export const LABEL_FRAGMENT: TypedDocumentNode<LabelDTO> = gql`
  fragment labelFragment on AbTestsParametersLabel {
    label
  }
`
